import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentPage } from 'selectors/location'
import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'
import { useAccessIntegration } from '../../useAccessIntegration'

const IntegrationsSection = ({ className }) => {
  const [open, setOpen] = useState(false)
  const isActive = useSelector(selectCurrentPage) === SETTINGS_INTEGRATIONS_PAGE

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])

  const handleClickIntegration = useAccessIntegration(handleCloseMenu)

  const overlay = useMemo(
    () => (
      <Menu
        onClose={handleCloseMenu}
        handleClickIntegration={handleClickIntegration}
      />
    ),
    [handleCloseMenu, handleClickIntegration]
  )

  return (
    <ButtonWithMenu
      css={className}
      isActive={isActive}
      open={open}
      setOpen={setOpen}
      overlay={overlay}
    >
      Apps
    </ButtonWithMenu>
  )
}

export default IntegrationsSection
